<template>
    <v-layout row wrap class="experience_layout">
        <v-flex xs12 sm4 class="custom_search">
            <v-text-field v-model="search" solo label="Search" maxlength="50" clearable append-icon="search" />
        </v-flex>
        <v-flex xs12 sm5 class="custom_sort">
            <v-select v-model="selectSortDescription" :items="listSortDescription" label="Tri" hide-details
                      return-object single-line append-icon="sort" solo />
            <v-btn @click="orderSort = !orderSort">
                <v-icon v-if="orderSort">
                    fas fa-long-arrow-alt-up
                </v-icon>
                <v-icon v-else>
                    fas fa-long-arrow-alt-down
                </v-icon>
            </v-btn>
        </v-flex>
        <v-flex xs12>
            <experience-grid :sort="selectSortCallback" :order="orderSort" :search="search" />
        </v-flex>
    </v-layout>
</template>

<script>

    export default {
        name: 'ExperienceContent',
        components: {
            ExperienceGrid: () => import('./ExperienceGrid')
        },
        data: () => ({
            search: null,
            listSort: [
                {
                    description: 'Tri par date de mise à jour',
                    callback: (a, b) => {
                        return b.update.localeCompare(a.update);
                    }
                },
                {
                    description: 'Tri par date de création',
                    callback: (a, b) => {
                        return a.created.localeCompare(b.created);
                    }
                },
                {
                    description: 'Tri par ordre alphabétique',
                    callback: (a, b) => {
                        return a.name.localeCompare(b.name);
                    }
                }
            ],
            selectSortCallback: null
        }),
        computed: {
            selectSortDescription: {
                get () {
                    return this.$store.state.experiences.selectSortDescription;
                },
                set (selectSortDescription) {
                    this.$store.commit('experiences/SET_SELECT_SORT_DESCRIPTION', selectSortDescription);
                }
            },
            orderSort: {
                get () {
                    return this.$store.state.experiences.orderSort;
                },
                set (orderSort) {
                    this.$store.commit('experiences/SET_ORDER_SORT', orderSort);
                }
            },
            listSortDescription: function () {
                return this.listSort.map(x => x.description);
            }
        },
        watch: {
            selectSortDescription: function (newValue) {
                this.selectSortCallback = this.listSort.filter(x => x.description === newValue)[0].callback;
            }
        },
        mounted () {
            this.selectSortCallback = this.listSort.filter(x => x.description === this.selectSortDescription)[0].callback;
        }
    };
</script>

<style lang="scss" scoped>
    .experience_layout {
        width: 100% !important;
        height: 100% !important;
        margin: 0 !important;
    }

    .custom_search , .custom_sort{
        z-index: 0;
        padding: 5px 10px !important;
    }

    .custom_sort > div:first-child {
        width: calc(100% - 55px) !important;
        display: inline-block;
    }

    .custom_sort > button {
        width: 20px !important;
        min-width: 20px !important;
        display: inline-block;
        height: 48px !important;
        top: -1px;
    }
</style>
